
export default function About() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl md:text-5xl font-bold text-emerald-900 mb-6">
              会社概要
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              合同会社フジワンは、内装工事のトータルサポートを提供する専門企業です。お客様の理想を形にするため、設計から施工、アフターフォローまで一貫したサービスを提供しています。
            </p>
            
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-building-line text-xl text-emerald-700"></i>
                </div>
                <div>
                  <h3 className="font-bold text-emerald-900 mb-1">会社名</h3>
                  <p className="text-gray-600">合同会社フジワン</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-calendar-line text-xl text-emerald-700"></i>
                </div>
                <div>
                  <h3 className="font-bold text-emerald-900 mb-1">設立</h3>
                  <p className="text-gray-600">令和6年10月9日</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <div className="w-12 h-12 flex items-center justify-center bg-emerald-100 rounded-full flex-shrink-0">
                  <i className="ri-map-pin-line text-xl text-emerald-700"></i>
                </div>
                <div>
                  <h3 className="font-bold text-emerald-900 mb-1">所在地</h3>
                  <p className="text-gray-600">埼玉県春日部市藤塚1897番地4</p>
                </div>
              </div>
            </div>
          </div>

          <div className="relative">
            <div className="relative h-96 lg:h-full min-h-[400px] overflow-hidden">
              <img 
                src="https://readdy.ai/api/search-image?query=Professional%20interior%20construction%20company%20office%20with%20natural%20wooden%20elements%20and%20forest%20inspired%20design%2C%20modern%20workspace%20with%20green%20plants%2C%20clean%20and%20organized%20environment%2C%20natural%20lighting%2C%20minimalist%20Japanese%20style%2C%20professional%20atmosphere%2C%20simple%20background&width=800&height=600&seq=about-office-001&orientation=portrait"
                alt="会社概要"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/20 to-transparent"></div>
            </div>
          </div>
        </div>

        {/* Mission Section */}
        <div className="mt-20 text-center">
          <h3 className="text-3xl font-bold text-emerald-900 mb-8">私たちの使命</h3>
          <div className="grid md:grid-cols-3 gap-8">
            <div className="p-6">
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-shield-check-line text-3xl text-emerald-700"></i>
              </div>
              <h4 className="text-xl font-bold text-emerald-900 mb-3">品質へのこだわり</h4>
              <p className="text-gray-600">
                妥協のない品質管理と、細部まで行き届いた施工で、お客様の期待を超える仕上がりを実現します。
              </p>
            </div>

            <div className="p-6">
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-heart-line text-3xl text-emerald-700"></i>
              </div>
              <h4 className="text-xl font-bold text-emerald-900 mb-3">お客様第一</h4>
              <p className="text-gray-600">
                お客様の声に真摯に耳を傾け、一人ひとりのニーズに合わせた最適なソリューションを提供します。
              </p>
            </div>

            <div className="p-6">
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-full mx-auto mb-4">
                <i className="ri-leaf-line text-3xl text-emerald-700"></i>
              </div>
              <h4 className="text-xl font-bold text-emerald-900 mb-3">環境への配慮</h4>
              <p className="text-gray-600">
                自然との調和を大切にし、環境に優しい素材の選定と施工方法を積極的に取り入れています。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
